export interface BorderWidths {
  button: string
}

export const createBorderWidths = (): BorderWidths => ({
  button: '1px',
})
